module.exports = __webpack_public_path__ + "static/media/4.15465981.png";